import { EvidenceGroupType } from 'typings';

export const searchFilter = (searchValue: string, item = 'name') => (
  data: any
) =>
  searchValue.length
    ? data?.[item].toLowerCase().includes(searchValue.toLowerCase())
    : true;

export const phaseFilter = (options: number[]) => (data: any) => {
  if (!options.length) return true;
  if (options.find((id) => data?.pivot?.phase_id === id)) return true;
  return false;
};

export const optionsFilter = (options: number[], item: string) => (
  data: any
) => {
  if (!options.length) return true;
  if (options.find((id) => data?.[item].includes(id))) return true;
  return false;
};

export const categoryFilter = (options: number[]) => (data: any) => {
  if (!options.length) return true;
  if (
    options.find((id) =>
      data?.categories?.map((e: any) => e?.category?.id).includes(id)
    )
  )
    return true;
  return false;
};

export const sortFilter = (option: string) => (data: EvidenceGroupType) => {
  if (!option.length) return true;
  if (option === 'general.terms.all') return true;
  if (option === 'general.terms.projects' && data?.type === 'project')
    return true;
  if (option === 'general.terms.courses' && data?.type === 'training')
    return true;
  if (option === 'project.terms.activities' && data?.type === 'project')
    return true;
  if (option === 'project.terms.process-steps' && data?.type === 'project')
    return true;

  return false;
};

export const publicationFilter = (option: string, org: string) => (
  data: any
) => {
  if (!option.length) return true;

  if (option === 'course.terms.public-library' && data.visibility === 'public')
    return true;

  if (org === option && data.visibility === 'org') return true;

  if (option === 'course.terms.drafts' && !data?.is_published) return true;

  if (
    option === 'general.terms.private' &&
    data?.is_published &&
    data?.visibility === 'private'
  )
    return true;

  return false;
};

export const sourceFilter = (option: string, organisationId?: number) => (
  data: any
) => {
  const isGrowContent = option === 'Groow Content' || option === '';
  const isAllContent = option === 'All Content' || option === 'Alle Content';

  if (isAllContent) return true;
  if (isGrowContent) {
    if ([1, 973].includes(data?.author?.id)) return true;
    return false;
  }
  // organisation filter
  return data?.author?.organisation_id === organisationId;
};

export const reduceFilter = <T>(filters: ((d: any) => any)[], data: T): T =>
  filters.reduce((d: any, f: any) => d?.filter(f), data);
